export enum Environment {
  dev = 'dev',
  local = 'local',
  qa = 'qa',
  prod = 'prod',
}
